import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
//import { styled } from '@mui/material/styles';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';




const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class FileUpload extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {
	 showPassword:false,newshowpassword:false,OldshowPassword:false,oldpassword:'',newpassword:'',
	 
	 confirmshowpassword:false,changepasword:'',submitbtn:'Change Password',errormessage:'',erropen:'',btndisabled:false,confirmpassword:'',
	 open:false,errortype:'error',redirect:false,
	}
	      
	}
	

		



 myChangeHandler = (event) => {
  
  let nam = event.target.name;
  let val = event.target.value;	  
  this.setState({[nam]: val});	
  
   
}

handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


  componentWillMount()
  {
	 
	  
	  
	
  }
	

handleSubmit= (event) => {

 event.preventDefault();

   let oldpassword = this.state.oldpassword;
 
   let newpassword = this.state.newpassword;
  
   let confirmpassword = this.state.confirmpassword;
   
   if(oldpassword==="")
{
	
	this.setState({ errormessage:"Please Enter Old Password.", erropen: true });
    window.scrollTo({ top: 0 });
    return false;
	
	
	
}
   if(newpassword==="")
{
	
	this.setState({ errormessage:"Please Enter New Password.", erropen: true });
    window.scrollTo({ top: 0 });
    return false;
	
	
}
   
    if(confirmpassword==="")
{

	
	this.setState({ errormessage:"Please Enter Confirm Password.", erropen: true });
    window.scrollTo({ top: 0 });
    return false;
	
	
}
  
  if(newpassword!=confirmpassword)
  {
	
  this.setState({ errormessage:"Please ReType Correct Password.", erropen: true });
    window.scrollTo({ top: 0 });
    return false;
  }
  
this.setState({btndisabled:true,submitbtn:"Processing..."})

                      var formData = new FormData();
                      formData.append('action','changepassowrd')	
					  formData.append('us_id',localStorage.getItem("ISIuserid"))
					  formData.append('oldpassword',this.state.oldpassword)
					  formData.append('newpassword',this.state.newpassword)
					  
					 
					    axios.post(localStorage.getItem("ISIurl")+"ajaxuser.php", formData, {
						}).then(res =>{
							let strreturn=res.data; 	
								 if(strreturn === "1")
                                   
								   {
									  this.setState({ submitbtn:'Change Password',btndisabled:false,errormessage:"Password has been updated successfully.", erropen: true,errortype:'success',oldpassword:'',newpassword:'',confirmpassword:'', });
                                      window.scrollTo({ top: 0 });
                                      return false;
									   
									  localStorage.clear();
									   
									   
								   }
								 
						 
						
						});

		
	 }

  handleClickOldShowPassword = () => {
    
	this.setState({
            OldshowPassword: !this.state.OldshowPassword
          })
  };
  
  
  
    handleClickNewShowPassword = () => {
    
	this.setState({
            newshowpassword: !this.state.newshowpassword
          })
  };
  
  handleClickConfirmpassowrd = () => {
    
	this.setState({
            confirmshowpassword: !this.state.confirmshowpassword
          })
  };
  
  
  
  
handleMouseDownPassword1 = event => {
		  
    event.preventDefault();
	
  };	
  
	  handleMouseDownPassword2 = event => {
    event.preventDefault();
  };	
  handleMouseDownPassword3 = event => {
		  
    event.preventDefault();
	
  };	
  

	render() {
			  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		
		
    return (
  <React.Fragment>
	<div className="main">
	
 <p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  
	  
	  
  <div className="changepassword">
   
  <ul>
  
  <li>  
		  <p>Old Password <span className="validation">*</span></p>
		 
		<p>
		<TextField 
		
		 value={this.state.oldpassword}
		 name="oldpassword" 
		 onChange={this.myChangeHandler} 
		 type={this.state.OldshowPassword ? 'text' : 'password'}
		className="txtbox" 
			fullWidth
			inputProps={{ tabIndex: "1" }}
		 endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickOldShowPassword}
                  onMouseDown={this.handleMouseDownPassword1}  >
				  {this.state.OldshowPassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
		
         /></p>
 
  </li>
  
    <li>  
		  <p>New Password <span className="validation">*</span></p>
		 
		<p>
		<TextField 
		
		 value={this.state.newpassword}
		 name="newpassword" 
		 onChange={this.myChangeHandler} 
		 type={this.state.newshowpassword ? 'text' : 'password'}
		className="txtbox" 
		inputProps={{ tabIndex: "2" }}
			fullWidth
		 endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickNewShowPassword}
                  onMouseDown={this.handleMouseDownPassword2}  >
				  { this.state.newshowpassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
		
         /></p>
 
  </li>
  
      <li>  
		  <p>Confirm Password <span className="validation">*</span></p>
		 
		<p>
		<TextField 
		
		 value={this.state.confirmpassword}
		 name="confirmpassword" 
		 onChange={this.myChangeHandler} 
		 type={this.state.confirmshowpassword ? 'text' : 'password'}
		className="txtbox" 
		inputProps={{ tabIndex: "2" }}
			fullWidth
		 endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickConfirmpassowrd}
                  onMouseDown={this.handleMouseDownPassword3}  >
				  { this.state.confirmshowpassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
		
         /></p>
 
  </li>
  
  
  
  
  </ul>
 </div>
 
 
 
     <p className="aligncentr"> 
		  <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   {this.state.submitbtn}
</Button></p>
 
 </div>
 </React.Fragment>
    );
}

}